/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLocationShiftsQuantity200Response
 */
export interface GetLocationShiftsQuantity200Response {
    /**
     * 
     * @type {number}
     * @memberof GetLocationShiftsQuantity200Response
     */
    quantity: number;
}

/**
 * Check if a given object implements the GetLocationShiftsQuantity200Response interface.
 */
export function instanceOfGetLocationShiftsQuantity200Response(value: object): value is GetLocationShiftsQuantity200Response {
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    return true;
}

export function GetLocationShiftsQuantity200ResponseFromJSON(json: any): GetLocationShiftsQuantity200Response {
    return GetLocationShiftsQuantity200ResponseFromJSONTyped(json, false);
}

export function GetLocationShiftsQuantity200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLocationShiftsQuantity200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'quantity': json['quantity'],
    };
}

export function GetLocationShiftsQuantity200ResponseToJSON(json: any): GetLocationShiftsQuantity200Response {
    return GetLocationShiftsQuantity200ResponseToJSONTyped(json, false);
}

export function GetLocationShiftsQuantity200ResponseToJSONTyped(value?: GetLocationShiftsQuantity200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'quantity': value['quantity'],
    };
}

